// Create the Redux Store and the Browser History
import { createBrowserHistory, type Location } from "history";
import { applyMiddleware, legacy_createStore as createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension/developmentOnly";
import { thunk as thunkMiddleware } from "redux-thunk";
import DeveloperReducers from "../Reducers/DeveloperReducers";

export type LocationWithState<T> = Location & Partial<{
    state: undefined | T;
}>;

// Create router history
const browserHistory = createBrowserHistory();

// Prepare the Redux Store
const composeEnhancers = composeWithDevTools({
    trace: process.env.NODE_ENV !== "production",
});

export const store = createStore(
    DeveloperReducers(),
    composeEnhancers(
        applyMiddleware(
            thunkMiddleware
        )
    )
);

export const history = browserHistory;
